/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from 'react'
import { getStatistics } from '@services'

const UseData = () => {
  // Busca as estatísticas calculadas a partir dos dados armazenados
  const getData = () => getStatistics()

  return useMemo(
    () => ({
      getData,
    }),
    []
  )
}

export { UseData }
